export default __webpack_public_path__ + "static/media/6.05c98559.jpg";